import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import type { GetQueries } from "@typings/api";
import { isEmpty } from "@utils/formatters";
import type { GetRegistersResponse, RegistersFilters } from "./type";

async function getRegisters(
  query: GetQueries<RegistersFilters>,
): Promise<GetRegistersResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;

    params.append(key, String(value));
  });

  let url = apiPaths.registers.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetRegistersResponse>(url);

  return response.data;
}

export function useGetRegisters(
  query: GetQueries | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-registers`, JSON.stringify(query ?? {})],
    () => getRegisters(query ?? {}),
    mergedOptions,
  );
}
